<div class="page-not-found-container">
  <h1>404 - Page Not Found</h1>
  <p>{{ message }}</p>
  <a *ngIf="showRedirectLink" [routerLink]="redirectLink" class="go-home-link">Go back to Home</a>
</div>
